import ComparisonViewDeepDiveV2 from './comparisonViewDeepDiveV2'
export default ComparisonViewDeepDiveV2
